import {create} from 'zustand';
import {SelectedBilletStore} from './types';

export const useSelectedBilletStore = create<SelectedBilletStore>(set => ({
	selectedBillet: undefined,
	setSelectedBillet: billet => set({selectedBillet: billet}),
}));
